@if (doc(); as d) {
  <div
    class="fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden bg-black/90 p-4 sm:p-8"
    (click)="close()"
  >
    <!-- Barre d'outils -->
    <div
      class="absolute top-4 right-4 flex items-center gap-1 rounded-full z-[1000]"
      (click)="$event.stopPropagation()"
    >
      <button
        type="button"
        (click)="close()"
        title="Fermer (Échap)"
        aria-label="Fermer"
        appButton
        variant="outline"
        size="icon"
        class="rounded-full!"
      >
        <app-icon name="x" [size]="20" />
      </button>
    </div>

    <!-- Titre -->
    @if (d.label) {
      <span class="absolute top-4 left-1/2 -translate-x-1/2 max-w-[60vw] truncate text-white/70 text-sm">
        {{ d.label }}
      </span>
    }

    <!-- Document -->
    <div
      class="h-full max-h-[90vh] w-full max-w-7xl overflow-hidden rounded-md bg-white shadow-2xl"
      (click)="$event.stopPropagation()"
    >
      <ngx-extended-pdf-viewer
        [src]="d.url"
        [filenameForDownload]="d.label || 'document.pdf'"
        height="100%"
        language="fr-FR"
        zoom="page-width"
        [showOpenFileButton]="false"
        [showPresentationModeButton]="false"
        [showSecondaryToolbarButton]="false"
        [showDrawEditor]="false"
        [showTextEditor]="false"
        [showStampEditor]="false"
        [showHighlightEditor]="false"
        [showSignatureEditor]="false"
        [showCommentEditor]="false"
      />

    </div>
  </div>
}
